<template>
    <div class="content">
        <img class="banner-img" src="../../../public/img/partners/head_img.jpg">
        <h6 class="title_g">PARTNERS<br><p>Our Partners</p></h6>
        
        <div class="partners_box">
            <div class="partners main">
                <div><div><img draggable="false" src="../../../public/img/partners/partner1.jpg" alt="costway"></div></div>
                <div><div><img draggable="false" src="../../../public/img/partners/partner2.jpg" alt="GOPLUS"></div></div>
                <div><div><img draggable="false" src="../../../public/img/partners/partner3.jpg" alt="target"></div></div>
                <div><div><img draggable="false" src="../../../public/img/partners/partner5.jpg" alt="Walmart"></div></div>
                <div><div><img draggable="false" src="../../../public/img/partners/partner6.jpg" alt="Disney"></div></div>
                <div><div><img draggable="false" src="../../../public/img/partners/partner7.jpg" alt="michaels"></div></div>
                <div><div><img draggable="false" src="../../../public/img/partners/partner8.jpg" alt="HOBBY LOBBY"></div></div>
                <div><div><img draggable="false" src="../../../public/img/partners/partner9.jpg" alt="Pride"></div></div>
                <div><div><img draggable="false" src="../../../public/img/partners/partner10.jpg" alt="amazon"></div></div>
                <div><div><img draggable="false" src="../../../public/img/partners/partner11.jpg" alt="ebay"></div></div>
                <div><div><img draggable="false" src="../../../public/img/partners/partner12.jpg" alt="JYSK"></div></div>
                <div><div><img draggable="false" src="../../../public/img/partners/partner13.jpg" alt="orion"></div></div>
                <div><div><img draggable="false" src="../../../public/img/partners/partner14.jpg" alt="Carrefour"></div></div>
                <div><div><img draggable="false" src="../../../public/img/partners/partner15.jpg" alt="ATB"></div></div>
                <div><div><img draggable="false" src="../../../public/img/partners/partner16.jpg" alt="F&H"></div></div>
                <div><div><img draggable="false" src="../../../public/img/partners/partner17.jpg" alt="FACKELMANN"></div></div>
                <div><div><img draggable="false" src="../../../public/img/partners/partner18.jpg" alt="Profil"></div></div>
                <div><div><img draggable="false" src="../../../public/img/partners/partner19.jpg" alt="JIM BEAM"></div></div>
                <div><div><img draggable="false" src="../../../public/img/partners/partner20.jpg" alt="tesco"></div></div>
                <div><div><img draggable="false" src="../../../public/img/partners/partner21.jpg" alt="MAX"></div></div>
                <div><div><img draggable="false" src="../../../public/img/partners/partner22.jpg" alt="DAISO"></div></div>
                <div><div><img draggable="false" src="../../../public/img/partners/partner23.jpg" alt="AVON"></div></div>
                <div><div><img draggable="false" src="../../../public/img/partners/partner24.jpg" alt="Betterware"></div></div>
                <div><div><img draggable="false" src="../../../public/img/partners/partner25.jpg" alt="makro"></div></div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Partners',
}
</script>

<style lang="less" scoped>
    .content { background-color: #f5f4f4; }
    .partners_box { width: 100vw; overflow: auto; padding-bottom: 3rem; }
    .partners { width: 100%; font-size: 0; }
    .partners > div { display: inline-block; width: calc(33.3vw - .4rem); margin: .2rem; background-color: #fff; vertical-align: top; transition: .2s all ease; }
    .partners > div > div { height: 0; padding-bottom: 100%; position: relative; }
    .partners img { user-select: none; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 60%; }
</style>